import { render, staticRenderFns } from "./OfferOrPlanItem.vue?vue&type=template&id=0c7fbedc&scoped=true&"
import script from "./OfferOrPlanItem.vue?vue&type=script&lang=js&"
export * from "./OfferOrPlanItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferOrPlanItem.vue?vue&type=style&index=0&id=0c7fbedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fbedc",
  null
  
)

export default component.exports